<!--<c-header class="mb-4 d-print-none" position="sticky">-->
<ng-container>
  <c-container [fluid]="true">
    <button
      toggle="visible"
      cHeaderToggler
      [cSidebarToggle]="sidebarId"
      class="ps-1"
    >
      <svg cIcon
           name="cilMenu"
           size="lg"
      ></svg>
    </button>
    <c-header-nav class="flex-1 me-auto">

    <div class="header-brand flex items-center gap-3 cursor-default select-none">
      <img src="assets/brand/logo.svg" alt="Logo" class="logo-img w-9 h-9 object-cover shrink-0 rounded-full"/>
      <div class="title-group flex flex-col justify-center leading-tight">
        <span class="main-title main-title-full font-medium">Hệ thống quản lý mã hoá lâm sàng</span>
        <span class="main-title main-title-short font-medium" aria-hidden="true">HTQL MHLS</span>
        <span class="sub-title sub-title-full uppercase">Clinical Coding Management System</span>
        <span class="sub-title sub-title-short uppercase" aria-hidden="true">CCMS</span>
      </div>
    </div>
    </c-header-nav>

    <button
      type="button"
      class="ai-assistant-banner me-2 d-flex align-items-center gap-2 text-decoration-none border-0"
      (click)="navigateToChatbot()"
      title="Trợ lý AI"
      aria-label="Trợ lý AI"
    >
      <span class="ai-icon-wrapper">
        <!-- Sparkles (Lucide) -->
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/>
          <path d="M20 3v4"/><path d="M22 5h-4"/><path d="M4 17v2"/><path d="M5 18H3"/>
        </svg>
      </span>
      <span class="ai-banner-text">
        <span class="ai-label">Trợ lý AI</span>
      </span>
    </button>

    <c-header-nav class="me-2 header-action-btn" *ngIf="isShowLang">
            <app-language [langKey]="langKey"></app-language>
    </c-header-nav>

    <c-dropdown #notifDropdown placement="bottom-end" class="me-1 header-action-btn" *ngIf="isShowLang">
      <button
        cButton
        cDropdownToggle
        class="p-2 border-0 bg-white d-flex align-items-center justify-content-center bell-button shadow-sm"
        [class.bell-ringing]="unreadCount > 0"
        style="color: #4b5563;"
        (click)="markAsRead()"
      >
        <svg cIcon name="cilBell" size="lg"></svg>
        <span *ngIf="unreadCount > 0" class="badge-notification">{{ unreadCount }}</span>
      </button>
      <ul cDropdownMenu class="notification-dropdown">
        <li class="dropdown-header-notif px-3 py-2 border-bottom">
          <strong>Thông báo</strong>
        </li>
        <ng-container *ngIf="notifications.length > 0; else noNotifications">
          <li *ngFor="let item of notifications" cDropdownItem (click)="markAsRead(); viewAllNotifications()" class="notif-item">
            <div class="notif-title">{{ item.title }}</div>
            <div class="notif-time">{{ item.timestamp }}</div>
          </li>
        </ng-container>
        <ng-template #noNotifications>
          <li cDropdownItem class="text-center text-muted py-3">
            Không có thông báo
          </li>
        </ng-template>
        <li class="dropdown-footer-notif px-3 py-2 border-top bg-light">
          <a (click)="viewAllNotifications()" class="view-all-link" style="cursor: pointer;">
            Xem tất cả
            <svg cIcon name="cilArrowRight" size="sm"></svg>
          </a>
        </li>
      </ul>
    </c-dropdown>

  </c-container>
  <c-header-divider></c-header-divider>
  <c-container [fluid]="true">
    <c-breadcrumb-router class="ms-1"></c-breadcrumb-router>
  </c-container>
</ng-container>